import { IContainerPatientFormTemplateLaunchProps } from '@lumahealthhq/ui-common';
import { Theme } from '@lumahealthhq/ui-core';

const defaultProps: Partial<IContainerPatientFormTemplateLaunchProps> = {
  disableGutters: true,
};

const styleOverrides = {
  root: ({ theme }: { theme: Theme }) => ({
    backgroundColor: theme.palette.primary[25],
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    '& .MuiPaper-root': {
      background: 'none',
      maxHeight: 'fit-content',
      minWidth: theme.breakpoints.values.sm,
      maxWidth: theme.breakpoints.values.sm,
      padding: theme.spacing(5),
    },
    [theme.breakpoints.down('md')]: {
      padding: 0,
      '& .MuiPaper-root': {
        minWidth: '100%',
        minHeight: '100%',
      },
    },
  }),
};

export default { defaultProps, styleOverrides };
